"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bitlayer = void 0;
exports.bitlayer = {
    "addresses": {
        "ProxyAdmin": "0xF04B152d2E27b5d975A2eb6b7F39EA42A74841Ac",
        "Multicall2": "0x5B256fE9e993902eCe49D138a5b1162cBb529474",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x30E148a79B898EFa1Ab1285F5Eca71972a7e0acE",
        "FeedPriceOracle": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "CompLogic": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
        "RedemptionManager": "0xdD9C863197df28f47721107f94eb031b548B5e48",
        "Timelock": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
        "Comptroller": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
        "JumpRate#Others": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
        "ZeroRate": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
        "sdrBTC": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
        "BTC": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x7032b30FEF73af49e314e5A09B449046ef046309",
        "suErc20": "0x3EC1D6e0B44c8a2a8855aEb71f35355459478482",
        "sdrBLBTC": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
        "BLBTC": "0x4e0dD7c16d2bBf873335cc21C72663b3EAE23014",
        "sdrsuBTC": "0x1fbDb3b715c82DCD52BCF06fcc18819951aa9264",
        "suBTC": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrBLBTC",
            "ctokenAddr": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
            "underlySym": "BLBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4e0dD7c16d2bBf873335cc21C72663b3EAE23014",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x1fbDb3b715c82DCD52BCF06fcc18819951aa9264",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrBTC",
            "ctokenAddr": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
            "underlySym": "BTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
            "tokens": [
                "BTC",
                "BLBTC",
                "BTC"
            ],
            "baseRatePerYear": "0.01",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
            "tokens": [
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=bitlayer.js.map